'use client'

import { useTranslations } from 'next-intl'

import { Paragraph } from '@graftcode/design-system'

import styles from './OnboardingLoader.module.scss'

export function OnboardingLoader() {
  // Hooks
  const t = useTranslations('onboarding')

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
        </div>

        <Paragraph size="sm" className={styles.message}>
          {t('loading')}
        </Paragraph>
      </div>
    </div>
  )
}
